import { queryBuilder } from '../../utils';

import { PANEL_TABLE_COLUMNS_ID } from '../../constants';

const panelColumnMapping = {
  passed_interviews: 'passed',
  failed_interviews: 'failed',
  canceled_interviews: 'canceled',
  declined_interviews: 'declined',
  pending_interviews: 'pending',
  feedback_pending_interviews: 'feedbackPending',
  result_pending_interviews: 'resultPending',
  upcoming_interviews: 'upcoming',
  previous_interviews: 'past',
  total_interviews: 'total',
};

// applications_uploaded: 'applicationsUploaded',
//   scheduled_interviews: 'scheduled',
//   positions_filled: 'positionsFilled',

export function panelQueryBuilder(
  obj,
  columnMapping = panelColumnMapping,
  COLUMN_ID = PANEL_TABLE_COLUMNS_ID
) {
  const panelReportColumns = [];
  const otherParam = [];

  Object.keys(obj).forEach((key) => {
    if (COLUMN_ID.includes(key)) {
      panelReportColumns.push(key);
    } else {
      otherParam.push(key);
    }
  });

  const rangeQuery = panelReportColumns.reduce((acc, key) => {
    const schemaKey = columnMapping[key] || key; // use mapping if available, fallback to original key

    const parts = [];
    if (obj[key]?.min !== undefined && obj[key]?.min !== '') {
      parts.push(`${schemaKey}.min=${obj[key].min}`);
    }
    if (obj[key]?.max !== undefined && obj[key]?.max !== '') {
      parts.push(`${schemaKey}.max=${obj[key].max}`);
    }
    if (parts.length === 0) return acc;

    const joined = parts.join('&');
    return acc ? `${acc}&${joined}` : joined;
  }, '');

  const otherParamsObj = otherParam.reduce((acc, key) => {
    acc[key] = obj[key];
    return acc;
  }, {});

  const filterQuery = queryBuilder(otherParamsObj).replace(/^\?/, ''); // remove leading ?

  const queryParts = [];
  if (rangeQuery) queryParts.push(rangeQuery);
  if (filterQuery) queryParts.push(filterQuery);

  return queryParts.length > 0 ? `?${queryParts.join('&')}` : '';
}
